import { pantryColors } from '@pantry/ui'
import React from 'react'

const p = pantryColors

// HTML-styled toggle pill (mirrors `.rule-toggle` in
// `docs/pantry/2026.05.27/breadstack-loyalty-pro.html` lines 205-208).
//
//   .rule-toggle{40x22, radius 11, gray-200 bg, white knob, .on => accent bg + knob right}
//
// Implemented as a plain styled <button> so it is keyboard accessible without
// pulling in the bs-unified-ui Switch.
interface Props {
  checked: boolean
  onChange: (next: boolean) => void
  ariaLabel?: string
  disabled?: boolean
}

export const CouponLimitToggle: React.FC<Props> = ({
  checked,
  onChange,
  ariaLabel,
  disabled,
}) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      style={{
        position: 'relative',
        width: 40,
        height: 22,
        borderRadius: 11,
        border: 'none',
        padding: 0,
        background: checked ? p.brand.primary : p.gray[200],
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'background .2s',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: 2,
          left: 2,
          width: 18,
          height: 18,
          borderRadius: '50%',
          background: '#fff',
          boxShadow: '0 1px 3px rgba(0,0,0,.15)',
          transform: checked ? 'translateX(18px)' : 'translateX(0)',
          transition: 'transform .2s',
        }}
      />
    </button>
  )
}
